// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./coc-styles-designSystem-bundle.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSC Summit Design System reset styles */

.App {
    text-align: center;
}

/* responsive logo */
.coc-logo {
    -webkit-align-self: flex-center;
    -ms-flex-item-align: center;
    align-self: flex-center;
    -webkit-flex-shrink: 0;
    -moz-flex-shrink: 0;
    flex-shrink: 0;
    -webkit-box-flex: 0;
    -moz-box-flex: 0;
    -webkit-flex-grow: 0;
    flex-grow: 0;
    margin-left: -1rem;
    margin-right: 1.125rem;
    position: relative;
    width: 58px;
    height: 74px;
    display: inline-block;
    z-index: 1;
}

.coc-logo-mobile {
    display: block;
}

.coc-logo-desktop {
    display: none;
}

@media (min-width: 900px) {
    .coc-logo {
        -webkit-align-self: flex-start;
        -ms-flex-item-align: start;
        align-self: flex-start;
        margin-left: auto;
        /* margin-left: 1.125rem; */
        width: 144px;
        height: 68px;
    }

    .coc-logo-mobile {
        display: none;
    }

    .coc-logo-desktop {
        display: block;
    }
}

@media (min-width: 1200px) {
    .coc-logo {
        margin-right: 2.25rem;
        /* margin-left: 2.25rem; */
        width: 217px;
        height: 103px;
    }
}

@media print {
    .coc-logo {
        margin-left: 0;
        width: 144px;
        height: auto;
    }

    .coc-logo {
        display: inline-block;
        width: 144px;
        height: auto;
    }

    .coc-logo-mobile {
        display: none;
    }
}


/* Summit Design System overrides */
p {
    margin-bottom: inherit;
    max-width: inherit;
}

/* breadcrumbs */
ol li {
    list-style: none;
}

/* pager */
.MuiPagination-ul li {
    list-style: none;
}

/* form error block */
ul {
    margin-bottom: revert;
}

/* spinner */
.preload-spinner-container {
    width: auto;
}

/* calendar control icon */
::-webkit-calendar-picker-indicator {
    filter: invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);
    cursor: pointer;
}

    ::-webkit-calendar-picker-indicator:hover {
        filter: invert(20%) sepia(100%) saturate(2000%) hue-rotate(0deg) brightness(100%) contrast(100%);
    }

label {
    font-size: 20px;
}

input[type="checkbox"] {
    margin: 0;
    padding-top: 7px;
}

.RN_required {
    color: #822020;
    font-size: 11px;
    font-weight: 800;
    padding-left: 3px;
    padding-right: 3px;
}

.form-group {
    margin-bottom: 1.5rem;
}

.control-label {
    display: inline-block;
    font-weight: 500;
    margin-bottom: 0.5rem;
}

.input-wrapper {
    max-width: 83.3333%; /* Bootstrap col-sm-10 */
}

input,
select,
textarea {
    width: 100%;
    padding: 0.5rem;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.message-box {
    flex: 1 1 100%;
    max-width: 100%;
    background-color: #eee;
    padding: 1rem;
    margin-top: 2rem;
}

.form-layout {
    display: flex;
    gap: 2rem;
    margin-top: 5rem;
    align-items: flex-start;
}

.form-column {
    flex: 1 1 100%;
    max-width: 100%;
}

@media (min-width: 768px) {
    .form-column,
    .message-box {
        flex: 0 0 50%;
        max-width: 100%;
    }
}

.alert-success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
    padding: 5px 5px 5px 40px;
}

    .alert-success hr {
        border-top-color: #b1dfbb;
    }

    .alert-success .alert-link {
        color: #0b2e13;
    }

.thank-you-box {
    background: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAG1C;IACI,kBAAkB;AACtB;;AAEA,oBAAoB;AACpB;IACI,+BAA+B;IAC/B,2BAA2B;IAC3B,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,8BAA8B;QAC9B,0BAA0B;QAC1B,sBAAsB;QACtB,iBAAiB;QACjB,2BAA2B;QAC3B,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,0BAA0B;QAC1B,YAAY;QACZ,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;AACJ;;;AAGA,mCAAmC;AACnC;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;AACpB;;AAEA,UAAU;AACV;IACI,gBAAgB;AACpB;;AAEA,qBAAqB;AACrB;IACI,qBAAqB;AACzB;;AAEA,YAAY;AACZ;IACI,WAAW;AACf;;AAEA,0BAA0B;AAC1B;IACI,2FAA2F;IAC3F,eAAe;AACnB;;IAEI;QACI,gGAAgG;IACpG;;AAEJ;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB,EAAE,wBAAwB;AACjD;;AAEA;;;IAGI,WAAW;IACX,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;;QAEI,aAAa;QACb,eAAe;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,yBAAyB;AAC7B;;IAEI;QACI,yBAAyB;IAC7B;;IAEA;QACI,cAAc;IAClB;;AAEJ;IACI,gBAAgB;AACpB","sourcesContent":["/* CSC Summit Design System reset styles */\r\n@import 'coc-styles-designSystem-bundle.css';\r\n\r\n.App {\r\n    text-align: center;\r\n}\r\n\r\n/* responsive logo */\r\n.coc-logo {\r\n    -webkit-align-self: flex-center;\r\n    -ms-flex-item-align: center;\r\n    align-self: flex-center;\r\n    -webkit-flex-shrink: 0;\r\n    -moz-flex-shrink: 0;\r\n    flex-shrink: 0;\r\n    -webkit-box-flex: 0;\r\n    -moz-box-flex: 0;\r\n    -webkit-flex-grow: 0;\r\n    flex-grow: 0;\r\n    margin-left: -1rem;\r\n    margin-right: 1.125rem;\r\n    position: relative;\r\n    width: 58px;\r\n    height: 74px;\r\n    display: inline-block;\r\n    z-index: 1;\r\n}\r\n\r\n.coc-logo-mobile {\r\n    display: block;\r\n}\r\n\r\n.coc-logo-desktop {\r\n    display: none;\r\n}\r\n\r\n@media (min-width: 900px) {\r\n    .coc-logo {\r\n        -webkit-align-self: flex-start;\r\n        -ms-flex-item-align: start;\r\n        align-self: flex-start;\r\n        margin-left: auto;\r\n        /* margin-left: 1.125rem; */\r\n        width: 144px;\r\n        height: 68px;\r\n    }\r\n\r\n    .coc-logo-mobile {\r\n        display: none;\r\n    }\r\n\r\n    .coc-logo-desktop {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .coc-logo {\r\n        margin-right: 2.25rem;\r\n        /* margin-left: 2.25rem; */\r\n        width: 217px;\r\n        height: 103px;\r\n    }\r\n}\r\n\r\n@media print {\r\n    .coc-logo {\r\n        margin-left: 0;\r\n        width: 144px;\r\n        height: auto;\r\n    }\r\n\r\n    .coc-logo {\r\n        display: inline-block;\r\n        width: 144px;\r\n        height: auto;\r\n    }\r\n\r\n    .coc-logo-mobile {\r\n        display: none;\r\n    }\r\n}\r\n\r\n\r\n/* Summit Design System overrides */\r\np {\r\n    margin-bottom: inherit;\r\n    max-width: inherit;\r\n}\r\n\r\n/* breadcrumbs */\r\nol li {\r\n    list-style: none;\r\n}\r\n\r\n/* pager */\r\n.MuiPagination-ul li {\r\n    list-style: none;\r\n}\r\n\r\n/* form error block */\r\nul {\r\n    margin-bottom: revert;\r\n}\r\n\r\n/* spinner */\r\n.preload-spinner-container {\r\n    width: auto;\r\n}\r\n\r\n/* calendar control icon */\r\n::-webkit-calendar-picker-indicator {\r\n    filter: invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);\r\n    cursor: pointer;\r\n}\r\n\r\n    ::-webkit-calendar-picker-indicator:hover {\r\n        filter: invert(20%) sepia(100%) saturate(2000%) hue-rotate(0deg) brightness(100%) contrast(100%);\r\n    }\r\n\r\nlabel {\r\n    font-size: 20px;\r\n}\r\n\r\ninput[type=\"checkbox\"] {\r\n    margin: 0;\r\n    padding-top: 7px;\r\n}\r\n\r\n.RN_required {\r\n    color: #822020;\r\n    font-size: 11px;\r\n    font-weight: 800;\r\n    padding-left: 3px;\r\n    padding-right: 3px;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.control-label {\r\n    display: inline-block;\r\n    font-weight: 500;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.input-wrapper {\r\n    max-width: 83.3333%; /* Bootstrap col-sm-10 */\r\n}\r\n\r\ninput,\r\nselect,\r\ntextarea {\r\n    width: 100%;\r\n    padding: 0.5rem;\r\n    font-size: 1rem;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n}\r\n\r\n.message-box {\r\n    flex: 1 1 100%;\r\n    max-width: 100%;\r\n    background-color: #eee;\r\n    padding: 1rem;\r\n    margin-top: 2rem;\r\n}\r\n\r\n.form-layout {\r\n    display: flex;\r\n    gap: 2rem;\r\n    margin-top: 5rem;\r\n    align-items: flex-start;\r\n}\r\n\r\n.form-column {\r\n    flex: 1 1 100%;\r\n    max-width: 100%;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .form-column,\r\n    .message-box {\r\n        flex: 0 0 50%;\r\n        max-width: 100%;\r\n    }\r\n}\r\n\r\n.alert-success {\r\n    color: #155724;\r\n    background-color: #d4edda;\r\n    border-color: #c3e6cb;\r\n    padding: 5px 5px 5px 40px;\r\n}\r\n\r\n    .alert-success hr {\r\n        border-top-color: #b1dfbb;\r\n    }\r\n\r\n    .alert-success .alert-link {\r\n        color: #0b2e13;\r\n    }\r\n\r\n.thank-you-box {\r\n    background: #fff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
